import { z } from 'zod';
import { DiagnosisImagePoint } from '../ImageDiagnosis';

// PainCondition is the type for a condition option (e.g. "Orthopedic: OA").
export type PainCondition = {
  label: string;
  value: string;
};

// ImageDxPointValueSchema/ImageDxPointValue are the types for the value of an individual point on an image.
const ImageDxPointValueSchema = z.object({
  evaluations: z.record(z.string(), z.string().or(z.number())).optional(),
  conditions: z.array(z.string()).optional()
});
export type ImageDxPointValue = z.infer<typeof ImageDxPointValueSchema>;

// ImageDxPointValuesSchema//ImageDxPointValues are the types for the values of all points on an image.  This is
// essentially a map of point name to ImageDxPointValue.
export const ImageDxPointValuesSchema = z.record(z.string(), ImageDxPointValueSchema);
export type ImageDxPointValues = z.infer<typeof ImageDxPointValuesSchema>;

// isImageDxPointValues checks if a value is a ImageDxPointValues.  This also provides a type guard for TypeScript.
export const isImageDxPointValues = (value: unknown): value is ImageDxPointValues => {
  return ImageDxPointValuesSchema.safeParse(value).success;
};

// PointWithConditions is the type for a point on an image with al the conditions that could exist for that point.
// For example, a point on the neck shouldn't have hip dysplasia as a condition.
export type PointWithConditions = DiagnosisImagePoint & {
  conditions: PainCondition[];
};

// DxImageWithPointsAndConditions is the type for an image with points and conditions.  This is used to display an
// image with all the various points on it.  It also contains the conditions that can be selected for each point.
export type DxImageWithPointsAndConditions = {
  name: string;
  imageUrl: string;
  points: PointWithConditions[];
};
